import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  HStack,
  Image,
  Text,
  VStack,
  useMediaQuery,
  Pressable,
  Spacer,
  Box,
  Spinner,
} from "native-base";
import { COMMONFONTWEIGHT } from "../../../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../../../utils/screens";
import { Toaster } from "../../../../components/toaster";
import { PhotoDisplayFullScreen } from "../../../requestEventDetailPage/photosListing/modalChildren";
import { getQuickLinkImagesAPI } from "../../../../api/apis/quicklinks";
import NoDataFound from "../../../../components/noDataFound";
import ImageViewer from "../../../../components/imageViewer";
import { COLORS } from "../../../../utils/colors";
import AccordionDetail from "../../../../components/accordion";

const NewImagesListingQuickLink = () => {
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedImagePath, setSelectedImagePath] = useState("");
  const { activeTab } = useSelector((state) => {
    return state.event;
  });
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    getQuickLinkImages();
    setOpenIndex("");
  }, [activeTab]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const getQuickLinkImages = async () => {
    setIsLoading(true);
    let res = await getQuickLinkImagesAPI(activeTab);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let data = [];
      res &&
        res.data.data.data.image_review_details?.map((item) => {
          let image = {
            event_name: item.event_name,
            file_name: item.event_based_datas?.map((img) => {
              return img.file_name;
            }),
          };
          data.push(image);
        });
      setImages(data);
    }
    setIsLoading(false);
  };

  const openModal = () => {
    scrollToTop();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleImages = (index, path) => {
    setSelectedImagePath(path);
    openModal();
  };

  return (
    <>
      {isLoading ? (
        <Box mt={10} flex={1} alignItems="center" justifyContent="center">
          <Spinner color={COLORS.THEME_COLOR} size="lg" />
        </Box>
      ) : (
        <VStack>
          {images.length > 0 ? (
            images.map((item, ind) => {
              return (
                <>
                  <AccordionDetail
                    index={ind}
                    isOpen={isOpen && ind === openIndex}
                    setIsOpen={setIsOpen}
                    openIndex={openIndex}
                    setOpenIndex={setOpenIndex}
                    title={item.event_name}
                    content={
                      <>
                        <HStack
                          mt={MobileWindow ? 0 : 1}
                          flex={1}
                          // flexWrap={"wrap"}
                          w={"100%"}
                          flexDirection={"column"}
                        >
                          {item.file_name && (
                            <ImageViewer images={item.file_name}
                              showIndividualCheckboxes={false}
                            />
                          )}
                        </HStack>
                        <Spacer size={3}></Spacer>
                      </>
                    }
                    type=""
                  />
                  <Spacer size={MobileWindow ? 6 : 8}></Spacer>
                </>
              );
            })
          ) : (
            <NoDataFound dataName="image" />
          )}

          {showModal && (
            <PhotoDisplayFullScreen
              selectedImage={selectedImagePath}
              setSelectedImage={setSelectedImagePath}
              closeModal={closeModal}
              h="90%"
            />
          )}
        </VStack>
      )}
    </>
  );
};

export default NewImagesListingQuickLink;
